module.exports = __webpack_public_path__ + "static/media/the-staging-club.e3e02259.png";